import { createFileRoute } from '@tanstack/react-router';
import { PackagePortal } from '@/features/package-sharing/components/package-portal';
import { QueryClientProvider } from '@tanstack/react-query';
import { publicPackageQuery, publicQueryClient } from '@/features/package-sharing/queries';
import { useTranslations } from 'use-intl';

export const Route = createFileRoute('/p/$token')({
  loader: ({ params }) => publicQueryClient.query(publicPackageQuery(params.token)),
  component: PortalRoute,
  errorComponent: PortalUnavailable,
});
function PortalRoute() {
  const { token } = Route.useParams();
  return (
    <QueryClientProvider client={publicQueryClient}>
      <PackagePortal token={token} />
    </QueryClientProvider>
  );
}
function PortalUnavailable() {
  const t = useTranslations('features.packageSharing');
  return (
    <main className="max-w-lg mx-auto p-8">
      <h1 className="text-xl mb-3">{t('unavailable')}</h1>
      <p>{t('linkError')}</p>
    </main>
  );
}
